import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import Select from "react-select";
import "../../assets/css/inventorymanagement.css"

const DestinationMaster = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [lockStatus, setLockStatus] = useState(1)
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen,  setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [isLoadTrue, setIsLoadTrue] = useState(false)
  const [isFormLocked, setIsFormLocked] = useState(false);
  const [editFormData, setEditFormData] = useState({
    destination_store_id: "",
    destination_store_name: "",
    destination_store_address: "",
    region: "",
    type:"",
    is_active : ""
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    destination_store_id: "",
    destination_store_name: "",
    destination_store_address: "",
    region: "",
  });
  
    const columnWithDefs = [
  {
    headerName: "",
    field: "actions",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => {
    const {is_active}=params.data
      return (
    
      <div
        style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}
      >
        <button
          title="Edit"
          className="mt-2"
          style={{
            height: "30px", 
            width: "60px",  // Adjust width to ensure the button fits
            padding: "0 10px",  // Optional: Adjust padding for appearance
            border: "1px solid #93385D",
            borderRadius: "4px",
            // cursor: is_active === 0 ? "not-allowed" : "pointer",
            backgroundColor: is_active === 0 ? "#da86a7ff" : "#F4EBEF",
            fontSize: "0.8rem",  // Optional: Adjust font size for readability
            color: is_active === 0 ? "white" : "#93385D",  // Optional: Customize button text color;
          }}
          // disabled={is_active === 0}
          onClick={() => handleEdit(params.data)}
        >
          Edit
        </button>
      </div>
    )},
  },
  {
    headerName: "",
    field: "delete",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => {
      const {is_active}=params.data
      return (
       
      <div style={{
        height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
      }}>
          <button
              title="Delete"
              disabled={is_active === 1}
              style={{
                height: "30px",
                width: "60px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: "4px",
                cursor: is_active === 1 ? "not-allowed" : "pointer",
                

              }}
              onClick={() =>
               handleDelete(params.data)}>
             <RiDeleteBin5Line
            style={{
              color: is_active === 1 ? "transparent" :"red",  // greyed out if disabled
              fontSize: "20px",
            }}
          />          </button>
      </div>
    
            )},
  },
  {
    headerName: "Destination Store ID",
    field: "destination_store_id",
    tooltipField: "destination_store_id",
    sortable: true,
    
    resizable: true,
    flex: 1,
     cellStyle: (params) => {
    if (params.data.is_active === 0) {
      return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
    }
    return null;
  },

  },
  {
    headerName: "Destination Store Name",
    field: "destination_store_name",
    tooltipField: "destination_store_name",
    sortable: true,
    
    resizable: true,
    flex: 1,
     cellStyle: (params) => {
    if (params.data && params.data.is_active === 0) {
      return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
    }
    return null; // default style
  },
  },
  {
    headerName: "Destination Store Address",
    field: "destination_store_address",
    tooltipField: "destination_store_address",
    sortable: true,
    
    resizable: true,
    flex: 1,
     cellStyle: (params) => {
    if (params.data && params.data.is_active === 0) {
      return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
    }
    return null; // default style
  },
  },
  {
    headerName: "Region",
    field: "region",
    tooltipField: "region",
    sortable: true,
    
    resizable: true,
    flex: 1,
     cellStyle: (params) => {
    if (params.data && params.data.is_active === 0) {
      return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
    }
    return null; // default style
  },
  },
   {
    headerName: "Type",
    field: "type",
    tooltipField: "type",
    sortable: true,
    
    resizable: true,
    flex: 1,
    valueGetter : (params) => {
      return params.data.type === "warehouse" ? "Warehouse" : "Dark Store";
    },
     cellStyle: (params) => {
    if (params.data && params.data.is_active === 0) {
      return { backgroundColor: "#da86a7ff", color: "white", fontWeight: "bold" };
    }
    return null; // default style
  },
  },
   {
  headerName: "Status",
  field: "is_active",
  width: 250,
  valueGetter: (params) => {
    const { is_active } = params.data;
    return is_active === 0 ? "In - Active" : "Active";
  },
  cellStyle: (params) => {
    if (params.node.rowPinned === "bottom") {
      return { fontWeight: "bold", backgroundColor: "#f5f5f5ff" };
    }
    if (params.value === "In - Active") {
      return {
        backgroundColor: "#da86a7ff",
        color: "white",
        fontWeight: "bold",
        
      };
    }
    return null;
  },
}

    ];

  const resetFormData = () => {
    setEditFormData({ 
     destination_store_id: "",
      destination_store_name: "",
      destination_store_address: "",
      region: "",
      type : "",
      is_active : ""
    });
    setDuplicatedEditData({
      destination_store_id: "",
      destination_store_name: "",
      destination_store_address: "",
      region: "",
      type :"",
      is_active : ""
    });
  };
  
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData()
    setUploadedFileData([]);
  };

  const onClickAddNewProduct = () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1)
    setSliderCl("slider-25");
    setSliderTitle("Add New Destination");
    setOverlyBlock("show-m");
  };

    const handleEdit = (row) => {
    setSliderOpen(true);
    setSliderType(3); 
    setSliderCl("slider-25");
    setSliderTitle(`Edit Product - ${row.destination_store_id}`);
    setOverlyBlock("show-m");
    setLockStatus(row.is_active)
    setEditFormData({
      destination_store_id: row.destination_store_id || "",
      destination_store_name: row.destination_store_name || "",
      destination_store_address: row.destination_store_address || "",
      region: row.region || "",
      is_active:row.is_active 
    });

    setDuplicatedEditData({
      destination_store_id: row.destination_store_id || "",
      destination_store_name: row.destination_store_name || "",
      destination_store_address: row.destination_store_address || "",
      region: row.region || "",
      is_active:row.is_active 
    });
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
   
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }
  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("masters/getDestinationMasterData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const data = response.data.data
          const updatedData = data.filter(item => item.is_delete !== 1)
          setRowData(updatedData);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Destination master data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Destination master data:", error);
      setBasicTitle("Failed to fetch Destination master data");
      setBasicType("error");
      setShow(true);
    }
  }
  

  useEffect(() => {
    const getData = async () => {
      setLoadshow("show-m");  
      setOverlayBlock("show-m");
        await getSkuMasterData()
      setLoadshow("show-n");  
      setOverlayBlock("show-n");
      }
    getData()

  }, []);

const closeAlert = () => {
   const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }
  setUploadedFileData([]);
  setFile(null)
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
  setShowDeletePopup(false)
  setSliderOpen(false)
  resetFormData();
};

const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Destination Store Id",
        "Destination Store Name",
        "Destination Store Address",
        "Region",
      ]
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_destination_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });
      const mapping = {
        "Destination Store Id": "destination_store_id",
        "Destination Store Name": "destination_store_name",
        "destination Store address": "destination_store_address",
        "Region": "region"
      };

      function toSnakeCase(str) {
          return str
            .trim()
            .replace(/\s+/g, '_')           // replace spaces with underscores
            .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
            .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
        }

      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            newItem[mapping[key]] = item[key];
          } else {
            newItem[toSnakeCase(key)] = item[key];
          }
        }
        return newItem;
      });

      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };
  
  const onClickingFileSubmit = async () => {
    if(uploadedFileData.length === 0){
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }
    const params = { masterData: uploadedFileData };
      try {
        const response = await redirectURL.post(
          "masters/storeDestinationMasterData",
          params
        );
        if (response.data.status === "success") {
          setUploadedFileData([])
          await getSkuMasterData();
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("success");
          setBasicTitle("Data Uploaded Successfully");
             setIsLoadTrue(true)

            // User Action Triggering Starts Here
            var userData = {
              email: localStorage.getItem("email"),
              user_code: localStorage.getItem("user_code"),
              action: "Bulk Uploaded Destination",
              status: "Success",
              path: window.location.pathname
            }
            triggerUserAction(userData)
          // User Action Triggering Ends Here
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("info");
          setBasicTitle("Data Upload Failed");
          setIsLoadTrue(true)

          // User Action Triggering Starts Here
          var userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Bulk Uploaded Destination",
            status: "Failure",
            path: window.location.pathname
          }
          triggerUserAction(userData)
        // User Action Triggering Ends Here
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred";
        setUploadedFileData([])
        setShow(true);
        setBasicType("info");
        setBasicTitle(errorMessage);
        setIsLoadTrue(true)
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      }
  };

  const onClickUploadSkuMasterData = (event) => {
    setUploadedFileData([])
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Upload Destination Master Data");
    setOverlyBlock("show-m");
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const onClickingUpdateSkuData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");  
    const params = {  
      destination_store_id: editFormData.destination_store_id,
      destination_store_name: editFormData.destination_store_name,
      destination_store_address: editFormData.destination_store_address,
      region: editFormData.region,
      is_active: editFormData.is_active   
    };

    // console.log(params,"params");
    
    const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
      (key) => duplicatedEditData[key] !== editFormData[key]
    );



    if (!isNeedtoUpdate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("No changes made to Destination data");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post(
        "masters/updateDestinationMaster",
        params
      );

      if (response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Destination Data Updated Successfully");

        if (editFormData.is_active === 1) {
         setIsFormLocked(true);
  }

        const updatedRowData = rowData.map((row) =>
          row.destination_store_id === editFormData.destination_store_id ? editFormData : row
        );

        setRowData(updatedRowData);

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Edited Destination",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to update Destination data");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Edited Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
      
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update Destination data");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Edited Destination",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  const handleAddSkuProduct = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {
      destination_store_id: editFormData.destination_store_id,
      destination_store_name: editFormData.destination_store_name,
      destination_store_address: editFormData.destination_store_address,
      region: editFormData.region,
      type : editFormData.type,
      // is_active: editFormData.is_active
    };

    // console.log(params)

    const validationErrors = Object.keys(params).filter(
      (key) => !params[key] || params[key].trim() === ""
    );
   params.is_active=editFormData.is_active

    if (validationErrors.length > 0) {
      // setShow(true);
      // setBasicType("info");
      alert(`Please fill in all required fields: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    const validSkuCode = /^[a-zA-Z0-9_-]+$/.test(params.destination_store_id);  
    // const validatemoq = /^[0-9]+$/.test(params.minimum_order_quantity);
    // if (!validatemoq) {
    //   setShow(true);
    //   setBasicType("info");
    //   setBasicTitle("Minimum Order Quantity must be a valid number");
    //   setLoadshow("show-n");
    //   setOverlayBlock("show-n");
    //   return;
    // }
    if (!validSkuCode) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Destination Id can only contain letters, numbers, underscores, and hyphens");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/addNewDestination",
        params
      );
   
      if (response.status === 200 && response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("New Destination Added Successfully");
        // setRowData((prevRowData) => [...prevRowData, params]);

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New Destination",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here

      } else {
        // console.error("Failed to add new Destination:", response.data);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to add New Destination");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
     
    } catch (error) {
      const message = error.response?.data?.message || "An error occurred";
      setShow(true);
      setBasicType("info");
      setBasicTitle(message);

      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Added New Destination",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { destination_store_id: selectedRow.destination_store_id };
    try { 
      const response = await redirectURL.post(
        "masters/deleteDestination",
        params
      );
      
      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Destination Delete Successfully");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted Destination",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to Delete Destination");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          aaction: "Deleted Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to Delete Destination");

      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Deleted Destination",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  };

  const onClickDeletePopupCancelBtn = () => {

      setOverlayBlock("show-n");
      setShowDeletePopup(false);
  };

const statusOptions = [{label: "Active", value: 1}, {label: "In Active", value: 0}]

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>Destination Store Master</h1>
          </div>
          <div style={addButtonContainerStyle} className="col-sm-12 text-right pr-0 mb-4">
              <button 
                  onClick={onClickAddNewProduct}
                  style={{
                    ...addButtonStyle,
                      backgroundColor: "#93385D",
                      color: "#fff",
                      border: "2px solid #93385D",
                      marginRight: 15
                  }}
                  >
                    <IoMdAdd style={{color : "#fff", fontSize :"18px"}}/>
                    {" Add"}
              </button>
              <button
              onClick={onClickUploadSkuMasterData}

                className="mr-2"
                style={{
                  ...addButtonStyle,
                  backgroundColor: "#F4EBEF",
                  color: "#93385D",
                  border: "2px solid #93385D",
                }}
            >
              < MdOutlineFileUpload style={{color : "#93385D", fontSize :"20px"}}/>
              &nbsp;
              Upload
            </button>
            </div>
            <div className="col-sm-12 p-0 pl-2 mt-6">
              <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={100}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{width : "25%"}}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
          
        </div>

      {sliderType === 1 && (
        <form style={{ padding: "20px" }} 
          onSubmit={(e) => {
            e.preventDefault();
            handleAddSkuProduct();
          }}> 
            <div className="form-group">
              <label htmlFor="plantId" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Destination Store Id <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
              <div id="plantId" >
                <input
                  type="text"
                  className="form-control"
                  id="destination_store_id"
                  pattern="[a-zA-Z0-9_-]+"
                  name="destination_store_id"
                  onChange={(e) => setEditFormData({ ...editFormData, destination_store_id: e.target.value })}
                  value={editFormData.destination_store_id}
                  placeholder="Enter Destination Id"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  required
                  autoComplete="off"
                  title="Destination Id can only contain letters, numbers, underscores, and hyphens"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="plantName" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Destination Store Name <span style={{color :"red", marginLeft : "5px"}}>*</span></label>
              <div id="plantName" >
                <input
                  type="text"
                  className="form-control"
                  id="destination_store_name"
                  name="destination_store_name"
                  placeholder="Enter Destination Code"
                  onChange={(e) => setEditFormData({ ...editFormData, destination_store_name: e.target.value })}
                  value={editFormData.destination_store_name}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                   autoComplete="off"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="destination_store_address" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Destination Store Address<span style={{color :"red", marginLeft : "5px"}}>*</span></label>
              <div id="destination_store_address" >
                <input
                  type="text"
                  className="form-control"
                  id="destination_store_address"
                  name="destination_store_address"
                  placeholder="Enter Destination Code"
                  onChange={(e) => setEditFormData({ ...editFormData, destination_store_address: e.target.value })}
                  value={editFormData.destination_store_address}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                autoComplete="off"

                />
              </div>

            </div>
            <div className="form-group">
              <label htmlFor="Region" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Region <span style={{color :"red", marginLeft : "5px"}}>*</span></label>  
              <div id="Region" >
                <input
                  type="text"
                  className="form-control"  
                  id="region"
                  name="region"
                  placeholder="Enter Region"
                  onChange={(e) => setEditFormData({ ...editFormData, region: e.target.value })}
                  value={editFormData.region}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                  autoComplete="off"

                />
              </div>
            </div>
            <div className="form-group">
              <label
                htmlFor="region"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "5px",
                  display: "block",
                }}
              >
                Type: <span style={{ color: "red", marginLeft: "5px" }}>*</span>
              </label>
              <div id="Region">
                <select
                  className="form-control"
                  id="region"
                  name="region"
                  onChange={(e) =>
                    setEditFormData({ ...editFormData, type: e.target.value })
                  }
                  value={editFormData.type}
                  style={{
                    width: "100%",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem",
                  }}
                >
                  <option value="">-- Select Type --</option>
                  <option value="warehouse">Warehouse</option>
                  <option value="darkstore">Darkstore</option>
                </select>
              </div>
            </div>

            {/* add */}
            {/* <div className="form-group">
              <label
                htmlFor="status"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "5px",
                  display: "block",
                }}
              >
                Status: <span style={{ color: "red", marginLeft: "5px" }}>*</span>
              </label>
              <div>
                <Select
                  name="is_active"
                  id="is_active"
                  value={statusOptions.find((e) => e.value === 1)}   // Always Active
                  options={statusOptions.filter((e) => e.value === 1)} // Only Active in dropdown
                />
              </div>
            </div> */}

            <div style={{
              textAlign: "right",
              marginTop: "10px"
            }}>
              <button
                type="submit"
                id="sample-download-button"
              // className="btn btn-success"
              // onSubmit={}
              // onClick={}
              >
                ADD
              </button>
            </div>
          </form>
        )}

        {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
              <div className="d-flex justify-content-end mb-10p">
                <button
                  id = "sample-download-button"
                  // className="btn btn-info"
                  onClick={downloadExcelTemplate}
                >
                  {"Download Sample Template"}
                </button>
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                value={file}
                id="bulkUploadFile"
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  // className="btn btn-success"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  onClick={(e)=> {
                    setLoadshow("show-m")
                    setOverlayBlock("show-m")
                    onClickingFileSubmit(e)
                  }}
                >
                  {"Submit"}
                </button>
              </div>
             

            </div>
          </div>
      )}
      {sliderType === 3 && (
        <form style={{ padding: "20px" }}
         onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation()
                onClickingUpdateSkuData();  
              }}
        >
          <div className="form-group">
            <label htmlFor="destination_store_id" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Destination Store Id <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="destination_store_id"
              name="destination_store_id"
              value={editFormData.destination_store_id}
              onChange={(e) => setEditFormData({ ...editFormData, destination_store_id: e.target.value })}
              placeholder="Enter Destination Store Id"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem",
                backgroundColor: "#f9f9f9",
                cursor: "not-allowed",
              }}
              disabled 
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="destination_store_name" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Destination Store Name <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="destination_store_name"
              name="destination_store_name"
              value={editFormData.destination_store_name}
              onChange={(e) => setEditFormData({ ...editFormData, destination_store_name: e.target.value })}
              placeholder="Enter Destination Name"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem",
                cursor: lockStatus === 0 ? "not-allowed" : "text",
              }}
              disabled={lockStatus === 0 } 
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="destination_store_address" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Destination Store Address<span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="destination_store_address"
              name="destination_store_address"
              value={editFormData.destination_store_address}
              onChange={(e) => setEditFormData({ ...editFormData, destination_store_address: e.target.value })}
              placeholder="Enter destination_store_address"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem",
                cursor: lockStatus === 0 ? "not-allowed" : "text"

              }}
              disabled={lockStatus === 0} 

              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="region" style={{
              fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Region <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control"
                id="region"
                name="region"
                value={editFormData.region}
                onChange={(e) => setEditFormData({ ...editFormData, region: e.target.value })}
                placeholder="Enter Region"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "0.9rem",
                  cursor: lockStatus === 0 ? "not-allowed" : "text"

                }}
                disabled={lockStatus === 0} 
                required
              />

              <div className="form-group">
                <label
                  htmlFor="status"
                  style={{
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "5px",
                    display: "block",
                  }}
                >
                  Status <span style={{ color: "red" }}>*</span>
                </label>

                <select
                  id="is_active"
                  name="status"
                  className="form-control"
                  value={editFormData.is_active}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      is_active: parseInt(e.target.value),
                    })
                  }
                  style={{
                    width: "100%",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem",
                    padding: "10px",
                    
                  }}
                  required
                >
                  <option value={1}>Active</option>
                  <option value={0}>In - Active</option>
                </select>
              </div>

            </div>
            <div style={addButtonContainerStyle}>
              <button
                type="submit"
                id="sample-download-button"
              >
                Update
              </button>
          </div>
        </form>
    )}
      </div>
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to Delete ${selectedRow ? selectedRow.destination_store_id : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
               Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
        <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

export default DestinationMaster;